const color = {
  white: "#ffffff",
  black: "#000000",
  pink: " #fc346e",
  yellow: "#ffef7e",
  blue: "#0080ff",
  input_text_gray: "#919191",
  input_text_gray_light: "#979797",
  input_text_gray_dark: "#7b7b7b",
  input_text_purple: "#AEA2F4",
  purple_primary: "#5B3DCB",
  purple_secondary: "#AD7AFF",
  purple_second: "#977BFF",
  purple_text: "#2d1f62",
  purple_dark: "#251562",
  purple_light: "#7662ED",
  purple_bg: "#F8F7FF",
  purple_bg_dark: "#F0EEFF",
  purple_bg_light: "#ECEAFF",
  toggle_disabled: "#B1B1B1",
  btn_disabled: "#c1c0c6",
};
const theme = {
  color,
};

export default theme;
// ${({ theme }) => theme.color.white};
